import { formatDateMoment, setCurrency } from 'utils/utils'
import { TABLE_COMPARISON } from 'configs/analytics/configTableRevenue'
import TabToggle from 'components/commons/tab-toogle'
import icArrowUp from 'assets/images/ic-arrow-up-right.svg'
import icArrowDown from 'assets/images/ic-arrow-down-left.svg'
import './table.scss'

export const RevenueComparison = ({ dataComparison, isLoading }) => {
    const currentPeriod = dataComparison?.current_period
    const previousPeriod = dataComparison?.previous_period
    const percentage = dataComparison?.percentage

    const isTextBold = (key) => {
        return ['total_sales', 'net_sales'].includes(key)
    }

    const getPercentage = (trend, value) => {
        let icon = ''
        let text = ''
        let className = ''

        switch (trend) {
            case 'up':
                icon = icArrowUp
                text = `Naik ${value?.toFixed(2)}%`
                className = 'text-blue-90'
                break
            case 'down':
                icon = icArrowDown
                text = `Turun ${value?.toFixed(2)}%`
                className = 'text-red-50'
                break
            case 'constant':
                text = 'Konstan'
                className = 'text-neutral-60'
                break
            default:
                return 0
        }

        return { icon, text, className }
    }

    return (
        <TabToggle
            title={'Revenue Comparison'}
            isLoading={isLoading}
            content={
                <table className={'avo__revenue_comparison w-full border-collapse text-sm'}>
                    <thead className={'font-medium text-neutral-70 bg-neutral-5 h-16'}>
                        <tr>
                            <th className={'border-r border-neutral-10'}>Attribute</th>
                            <th className={'border-r border-neutral-10'}>
                                <div className={'flex space-x-2 justify-center'}>
                                    <p>Periode Saat Ini</p>
                                    <div className={'flex space-x-2 font-regular'}>
                                        <div>{formatDateMoment(currentPeriod?.start_date, 'DD MMM YY')}</div>
                                        <div>-</div>
                                        <div>{formatDateMoment(currentPeriod?.end_date, 'DD MMM YY')}</div>
                                    </div>
                                </div>
                            </th>
                            <th className={'border-r border-neutral-10'}>
                                <div className={'flex space-x-2 justify-center'}>
                                    <p>Periode Sebelumnya</p>
                                    <div className={'flex space-x-2 font-regular'}>
                                        <div>{formatDateMoment(previousPeriod?.start_date, 'DD MMM YY')}</div>
                                        <div>-</div>
                                        <div>{formatDateMoment(previousPeriod?.end_date, 'DD MMM YY')}</div>
                                    </div>
                                </div>
                            </th>
                            <th>Presentase</th>
                        </tr>
                    </thead>
                    <tbody>
                        {TABLE_COMPARISON.map((item, index) => (
                            <tr key={index}>
                                <td
                                    className={`text-center p-4 text-blue-90 border-r border-neutral-10 ${isTextBold(item?.key) ? 'font-bold' : 'font-medium'}`}
                                >
                                    {item.attribute}
                                </td>
                                <td
                                    className={`text-center text-gray-95 border-r border-neutral-10 ${isTextBold(item?.key) ? 'font-bold' : 'font-medium'}`}
                                >
                                    {setCurrency(currentPeriod?.[item?.key])}
                                </td>
                                <td
                                    className={`text-center text-gray-95 border-r border-neutral-10 ${isTextBold(item?.key) ? 'font-bold' : 'font-medium'}`}
                                >
                                    {setCurrency(previousPeriod?.[item?.key])}
                                </td>
                                <td
                                    className={`text-center ${getPercentage(percentage?.[item?.key]?.state)?.className} ${isTextBold(item?.key) ? 'font-bold' : 'font-medium'}`}
                                >
                                    <div className={'flex items-center justify-center'}>
                                        {getPercentage(percentage?.[item?.key]?.state)?.icon && (
                                            <img
                                                src={getPercentage(percentage?.[item?.key]?.state)?.icon}
                                                alt='icon-trend'
                                            />
                                        )}
                                        <p className={'pl-2'}>
                                            {
                                                getPercentage(
                                                    percentage?.[item?.key]?.state,
                                                    percentage?.[item?.key]?.value,
                                                )?.text
                                            }
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            }
        />
    )
}
